import React, { useCallback, useState } from 'react';
import { useAudioContext } from '../contexts/AudioContext';
import { FaPlay } from 'react-icons/fa';

/**
 * Shown when the browser blocks audio.play() (autoplay / missing user gesture).
 * One tap resumes the shared chapter stream.
 */
function AudioPlaybackBlockedPrompt() {
  const { chapterAudio, chapterSnapshot } = useAudioContext();
  const [busy, setBusy] = useState(false);
  const blocked = Boolean(chapterSnapshot?.playbackBlocked);

  const onResume = useCallback(async () => {
    if (!chapterAudio || busy) return;
    setBusy(true);
    try {
      await chapterAudio.resume();
    } catch (e) {
      console.warn('Tap-to-resume failed:', e);
    } finally {
      setBusy(false);
    }
  }, [chapterAudio, busy]);

  if (!blocked) return null;

  return (
    <div
      className="fixed bottom-20 left-3 right-3 z-[70] flex items-center justify-between gap-3 rounded-2xl border border-amber-200 bg-white p-3 shadow-lg dark:border-amber-800 dark:bg-gray-900 sm:left-auto sm:right-4 sm:max-w-md"
      role="status"
    >
      <p className="text-sm text-gray-800 dark:text-gray-100">
        Audio is paused by the browser. Tap resume to continue listening.
      </p>
      <button
        type="button"
        onClick={onResume}
        disabled={busy}
        className="inline-flex shrink-0 items-center gap-2 rounded-full bg-teal-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-teal-700 disabled:opacity-60"
      >
        <FaPlay className="h-3 w-3" />
        {busy ? 'Resuming…' : 'Resume'}
      </button>
    </div>
  );
}

export default AudioPlaybackBlockedPrompt;
